export default "__VITE_ASSET__DBkla9aq__"